import {BlogGrid} from '@organisms/ContentBlocks/BlogGrid';
import {useDeviceStore, selectIsMobile} from 'features/ui/store/useDeviceStore';
import * as React from 'react';

import {IContentBlock} from 'features/blocks/types';
import {BlogItemPageViewModel} from 'features/template/viewModels/BlogItemPage';

import 'components/blocks/Text/BlogBlock/style.scss';

export interface BlogBlockType {
    title: string;
    blogItems: BlogItemPageViewModel[];
}
type Props = IContentBlock<BlogBlockType>;

export const BlogBlock: React.FunctionComponent<Props> = ({data, id}) => {
    const _isMobile = useDeviceStore(selectIsMobile);

    return (
        <BlogGrid
            headline={data.title}
            blogItems={data.blogItems}
            id={id}
        />
    )
};

